module.exports = __webpack_public_path__ + "img/spinner.37d830a0.gif";